// extracted by mini-css-extract-plugin
export default {"emblaViewport":"NC9qrpgAVHNn8wtnlxC5","emblaContainer":"vJUIdBN8NmJ_VP_UOQcG","emblaSlide":"TfeKkL2DWdG8EOAJG7vH"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"emblaViewport\":\"NC9qrpgAVHNn8wtnlxC5\",\"emblaContainer\":\"vJUIdBN8NmJ_VP_UOQcG\",\"emblaSlide\":\"TfeKkL2DWdG8EOAJG7vH\"}";
        // 1793273551199
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  